/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AIEvidenceResetRequest = {
  /**
   * start_fresh => permanently retire every PDF citation and Excel reference, AI and human, whatever their review state, and remove every AI suggestion card - later runs behave like first runs; clear_ai_evidence => the same for AI-created rows only, dismissed ones included, leaving human evidence in place; clear_ai_suggestions => remove only the PENDING suggestion cards and retire every pending AI citation, including a fresh one sitting under an accepted or dismissed card, which the drawer shows as its own pending card; processed cards keep their settled evidence. No mode moves a grid value or deletes a security, and retired evidence is never resurrected by a rerun or by a stale save.
   */
  mode: AIEvidenceResetRequest.mode;
};
export namespace AIEvidenceResetRequest {
  /**
   * start_fresh => permanently retire every PDF citation and Excel reference, AI and human, whatever their review state, and remove every AI suggestion card - later runs behave like first runs; clear_ai_evidence => the same for AI-created rows only, dismissed ones included, leaving human evidence in place; clear_ai_suggestions => remove only the PENDING suggestion cards and retire every pending AI citation, including a fresh one sitting under an accepted or dismissed card, which the drawer shows as its own pending card; processed cards keep their settled evidence. No mode moves a grid value or deletes a security, and retired evidence is never resurrected by a rerun or by a stale save.
   */
  export enum mode {
    START_FRESH = 'start_fresh',
    CLEAR_AI_EVIDENCE = 'clear_ai_evidence',
    CLEAR_AI_SUGGESTIONS = 'clear_ai_suggestions',
  }
}

